$(document).ready(function(){
  console.log("custom JS cargado!");
  
    /*
  $(document).on('submit', '#contact_form', function(e){
  	e.preventDefault();
    e.stopPropagation();
    if( document.getElementById('captchaForm').getAttribute('validate') == 'true' ){
    	$('#contact_form').trigger('submit');
    }else{
      	$('.rc-anchor-error-msg-container').text('An error occurred, please, reload page.');
    	$('.rc-anchor-error-msg-container').show();
    };
    
  });*/
  
  
  var getWidth = screen.width;
  var getInTouchBtn = document.querySelector('a[gotodraw="mobile"]')
  
  $(getInTouchBtn).click(function(){
    if(getWidth < 700){
      console.log("Boton clickeado GIT mobile")
      setTimeout(function(){

        $('.form-vertical').trigger('click');
      }, 200)
    }
  })
  
  $(document).on('click', 'a', function(e){
    if($(this).hasClass('btn--get_contact')){
      console.log("this");
      e.preventDefault();
      $(getInTouchBtn).trigger('click');
    }
  });
  
  
  $(document).click(function(e){

      
      setTimeout(function(){


      if($('#CartDrawer').hasClass('drawer--is-open') == true){
        console.log("drawer abierto")
        console.log(getWidth + " px")
        if(getWidth < 700){
          
          console.log("Celular con "+ screen.width + " px")
          $('#close_drawer_btn').click(function(e){
            e.stopPropagation();

            console.log("Drawer Cerrado on mobile")
            //location.href = 'https://www.innovategroup.agency/'
            $('#close_nav_menu').trigger('click')
          })
        }else{
          $('#close_drawer_btn').click(function(e){
            e.stopPropagation();

            console.log("Drawer Cerrado on desktop")
          })
        }
      }else{
        console.log("drawer cerrado")
      }


    }, 200)

    

  })
  
  $('.work-item').each(function(i) {
    if( i % 10 == 0 ) {
      $(this).nextAll().addBack().slice(0,10).wrapAll('<div class="inner-row"></div>');
    }
  });
  
  $('.work-list .feature-row').slick({
    	lazyLoad: 'ondemand',
    	slidesToScroll: 1,
    	dots: true
  });
  
  
  
  const SLICK = $('.work-list .feature-row').slick('getSlick');
  
  
var  newDotsHTML = '<div class="div-container-slick-cloned" role="toolbar"><ul class="ul-slick-cloned" role="tablist"><li><button onclick="prev();" data-slick-id="previous" class="gotoprevslick" type="button" data-role="none" role="button" tabindex="0"><</button></li>';
for(var i = 0; i < SLICK.slideCount; i++ ){
    newDotsHTML += `<li  aria-hidden="false" role="presentation" aria-selected="true" id="${ i }" li_elementox="0">
                      <button data-slick-id="${ i }" class="gotonewslick" type="button" data-role="none" role="button" tabindex="0">${ i + 1 }</button>
                  </li>`
}
  newDotsHTML += '<li><button onclick="next();" data-slick-id="next" class="gotonextslick" type="button" data-role="none" role="button" tabindex="0">></button></li></ul></div>'

  $(document.querySelector('div[role="toolbar"]').parentElement).prepend( newDotsHTML );

  $(document).on('click' , '.gotonewslick' , function( evt ){
    var number =  evt.target.getAttribute('data-slick-id')
    $('.work-list .feature-row').slick('slickGoTo' , parseInt(number));
  })
  
    $(document).on('click' , '.gotoprevslick' , function( evt ){
    $('.work-list .feature-row').slick('slickPrev');
  })
    
    
    
    $(document).on('click' , '.gotonextslick' , function( evt ){
    $('.work-list .feature-row').slick('slickNext');
  })

console.log( newDotsHTML )

/*  
if(location.href == "https://www.innovategroup.agency/pages/work"){
  setTimeout(function(){
      const SLICK = $('.work-list .feature-row').slick('getSlick');
    
    var itm = document.querySelector('div[role="toolbar"]');

    var cln = itm.cloneNode(true);

    document.querySelector('div[role="toolbar"]').parentElement.prepend( cln );

      
    document.querySelectorAll('div[role="toolbar"]')[0].setAttribute('field_arrows', 'top');
    //document.querySelectorAll('div[role="toolbar"]')[0].className = "";
    //document.querySelectorAll('div[role="toolbar"]')[0].classList.add('div-container-slick-cloned');
    document.querySelectorAll('div[role="toolbar"]')[1].setAttribute('field_arrows', 'bottom');
    
    
    document.querySelectorAll('div[role="toolbar"]')[0].children[1].style.display = "none";
    document.querySelectorAll('div[role="toolbar"]')[0].children[3].style.display = "none";
    document.querySelectorAll('div[role="toolbar"]')[0].parentElement.setAttribute('data-id', 'ul_para_append')
    
    
    
    
    document.querySelectorAll('div[role="toolbar"]')[0].children[0].style.bottom = "15px";
    document.querySelectorAll('div[role="toolbar"]')[0].children[2].style.bottom = "15px";
    document.querySelectorAll('div[role="toolbar"]')[0].children[2].setAttribute('elemento', '2');
    document.querySelectorAll('div[role="toolbar"]')[0].children[0].setAttribute('elemento', '0');	
    
    document.querySelectorAll('div[role="toolbar"]')[1].children[2].setAttribute('elementox', '2');
    document.querySelectorAll('div[role="toolbar"]')[1].children[0].setAttribute('elementox', '0');
    
    document.querySelectorAll('div[role="toolbar"]')[0].children[3].style.bottom = "35px";
    document.querySelectorAll('div[role="toolbar"]')[0].children[3].setAttribute('elemento', '3');


    
  
    var topCloneElements = document.querySelectorAll('div[role="toolbar"]')[0].children
    
    var originalCloneElements = document.querySelectorAll('div[role="toolbar"]')[1].children
  
    document.querySelectorAll('div[role="toolbar"]')[1].children[3].children[0].setAttribute('li_elementox', '0');
    document.querySelectorAll('div[role="toolbar"]')[1].children[3].children[1].setAttribute('li_elementox', '1');
    document.querySelectorAll('div[role="toolbar"]')[1].children[3].children[2].setAttribute('li_elementox', '2');
    document.querySelectorAll('div[role="toolbar"]')[1].children[3].children[3].setAttribute('li_elementox', '3');
    
    document.querySelectorAll('div[role="toolbar"]')[0].children[3].children[0].setAttribute('li_elemento', '0');
    document.querySelectorAll('div[role="toolbar"]')[0].children[3].children[1].setAttribute('li_elemento', '1');
    document.querySelectorAll('div[role="toolbar"]')[0].children[3].children[2].setAttribute('li_elemento', '2');
    document.querySelectorAll('div[role="toolbar"]')[0].children[3].children[3].setAttribute('li_elemento', '3');
    
   }, 200)*/
  
 /* var  newDotsHTML = '<ul class="slick-dots" style="bottom: 35px;" role="tablist" elemento="3">';
for(var i = 0; i < SLICK.slideCount; i++ ){
    newDotsHTML += `<li  aria-hidden="false" role="presentation" aria-selected="true" id="${ i }" li_elementox="0">
                      <button data-slick-id="${ i }" class="gotonewslick" type="button" data-role="none" role="button" tabindex="0">${ i + 1 }</button>
                  </li>`
}
newDotsHTML += '</ul>'

$(document.querySelector(document.querySelectorAll('div[role="toolbar"]')[0])).prepend( newDotsHTML );

$(document).on('click' , '.gotonewslick' , function( evt ){
  var number =  evt.target.getAttribute('data-slick-id')
  $('.work-list .feature-row').slick('slickGoTo' , parseInt(number));
})

console.log( newDotsHTML )*/
  
  
  /*
  $(document).on('click', 'div[field_arrows="top"]', function(e){
    
      console.log(e.target)
      if(e.target.getAttribute('elemento') == "0"){
          $('button[elementox="0"]').trigger('click');
      }else{
        if(e.target.getAttribute('elemento') == "2" ){
            $('button[elementox="2"]').trigger('click');
        }else{
          var listaElement = e.target.parentElement.getAttribute('li_elementox');
          //$('.work-list .feature-row').slick('slickGoTo', parseInt(listaElement));
              /*document.querySelectorAll('ul button').forEach(function(element){
            if(element.parentElement.getAttribute('li_elemento') == listaElement){
                $(element).trigger('click');
            }
          
          })*/

/*
        }
      }
  
  })

}*/

$('#translator_slide').click(function(e){
 
  e.preventDefault();
  console.log(e.target);
  var scrollElement = $(this).closest('a').attr('data-scroll');
  
  
    $('html,body').animate({
      scrollTop: $(`${scrollElement}`).offset().top},
                           'slow');
});

});